var _circle, _g, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPricingSheetIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 171,
    viewBox: "0 0 171 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 85.5,
    cy: 85.5,
    r: 85.5,
    fill: "#FFB168"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_1948)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 50.5,
    width: 20,
    height: 10,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.5862,
    y: 53,
    width: 6.51724,
    height: 5,
    rx: 2,
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.5,
    y: 50.5,
    width: 20,
    height: 10,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.5862,
    y: 53,
    width: 6.51724,
    height: 5,
    rx: 2,
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.5,
    y: 50.5,
    width: 20,
    height: 10,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.5862,
    y: 53,
    width: 6.51724,
    height: 5,
    rx: 2,
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.5,
    y: 50.5,
    width: 20,
    height: 10,
    fill: "#F0F0F0",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 60.5,
    width: 20,
    height: 10,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.5862,
    y: 63,
    width: 6.51724,
    height: 5,
    rx: 2,
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.5,
    y: 60.5,
    width: 20,
    height: 10,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.5862,
    y: 63,
    width: 6.51724,
    height: 5,
    rx: 2,
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.5,
    y: 60.5,
    width: 20,
    height: 10,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.5862,
    y: 63,
    width: 6.51724,
    height: 5,
    rx: 2,
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.5,
    y: 60.5,
    width: 20,
    height: 10,
    fill: "#F0F0F0",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 70.5,
    width: 20,
    height: 10,
    fill: "#F0F0F0",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.5,
    y: 70.5,
    width: 20,
    height: 10,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.5862,
    y: 73,
    width: 6.51724,
    height: 5,
    rx: 2,
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.5,
    y: 70.5,
    width: 20,
    height: 10,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.5862,
    y: 73,
    width: 6.51724,
    height: 5,
    rx: 2,
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.5,
    y: 70.5,
    width: 20,
    height: 10,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.586,
    y: 73,
    width: 6.51724,
    height: 5,
    rx: 2,
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 80.5,
    width: 20,
    height: 10,
    fill: "#F0F0F0",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.5,
    y: 80.5,
    width: 20,
    height: 10,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.5862,
    y: 83,
    width: 6.51724,
    height: 5,
    rx: 2,
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.5,
    y: 80.5,
    width: 20,
    height: 10,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.5862,
    y: 83,
    width: 6.51724,
    height: 5,
    rx: 2,
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.5,
    y: 80.5,
    width: 20,
    height: 10,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.586,
    y: 83,
    width: 6.51724,
    height: 5,
    rx: 2,
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 90.5,
    width: 20,
    height: 10,
    fill: "#F0F0F0",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.5,
    y: 90.5,
    width: 20,
    height: 10,
    fill: "#F0F0F0",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.5,
    y: 90.5,
    width: 20,
    height: 10,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.5862,
    y: 93,
    width: 6.51724,
    height: 5,
    rx: 2,
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.5,
    y: 90.5,
    width: 20,
    height: 10,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.586,
    y: 93,
    width: 6.51724,
    height: 5,
    rx: 2,
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 100.5,
    width: 20,
    height: 10,
    fill: "#F0F0F0",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.5,
    y: 100.5,
    width: 20,
    height: 10,
    fill: "#F0F0F0",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.5,
    y: 100.5,
    width: 20,
    height: 10,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.5862,
    y: 103,
    width: 6.51724,
    height: 5,
    rx: 2,
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.5,
    y: 100.5,
    width: 20,
    height: 10,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.586,
    y: 103,
    width: 6.51724,
    height: 5,
    rx: 2,
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 110.5,
    width: 20,
    height: 10,
    fill: "#F0F0F0",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.5,
    y: 110.5,
    width: 20,
    height: 10,
    fill: "#F0F0F0",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.5,
    y: 110.5,
    width: 20,
    height: 10,
    fill: "#F0F0F0",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.5,
    y: 110.5,
    width: 20,
    height: 10,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.586,
    y: 113,
    width: 6.51724,
    height: 5,
    rx: 2,
    fill: "#C0C0C0"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 50.5,
    width: 80,
    height: 70,
    rx: 3.5,
    stroke: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_1948"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 50,
    width: 81,
    height: 71,
    rx: 4,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingSheetIcon);
export default __webpack_public_path__ + "static/media/pricingSheetIcon.598d95d0da3b36b2dd2aebb37cf4d8d4.svg";
export { ForwardRef as ReactComponent };